import { Link } from 'gatsby';
import { EuiSpacer, EuiButton } from '@elastic/eui';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  EuiButton,
  BreadCrumbs,
  SEOHelmet,
  React
};